// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── TipTap Editor Styles — CMDB Docs ──────────────────────────────────────── */

/* Editor container */
.tiptap-editor-wrap {
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-card, #0d0f1a);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1;
}

/* Toolbar */
.tiptap-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 6px 10px;
  background: var(--bg-toolbar, rgba(255,255,255,.04));
  border-bottom: 1px solid var(--border);
  align-items: center;
}

.tiptap-toolbar-group {
  display: flex;
  gap: 1px;
  align-items: center;
}

.tiptap-toolbar-group + .tiptap-toolbar-group {
  margin-left: 4px;
  padding-left: 6px;
  border-left: 1px solid var(--border);
}

.tiptap-toolbar button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--text-secondary, rgba(255,255,255,.55));
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.12s, color 0.12s;
}

.tiptap-toolbar button:hover {
  background: var(--slate-200);
  color: var(--text-primary, #e2e8f0);
}

.tiptap-toolbar button.is-active {
  background: var(--accent, #6366f1);
  color: #fff;
}

.tiptap-toolbar button:disabled {
  opacity: 0.35;
  cursor: default;
}

.tiptap-toolbar select {
  height: 28px;
  border: 1px solid var(--border);
  border-radius: 4px;
  background: var(--bg-input, rgba(255,255,255,.05));
  font-size: 12px;
  padding: 0 6px;
  color: var(--text-primary, #e2e8f0);
  cursor: pointer;
}

/* ProseMirror content area */
.tiptap-editor-wrap .ProseMirror {
  flex: 1 1;
  padding: 1.5rem 2rem;
  outline: none;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 15px;
  line-height: 1.7;
  color: var(--text-primary, #e2e8f0);
  min-height: 400px;
  overflow-y: auto;
}

.tiptap-editor-wrap .ProseMirror > * + * {
  margin-top: 0.5em;
}

/* Headings */
.tiptap-editor-wrap .ProseMirror h1 {
  font-size: 1.85rem;
  font-weight: 800;
  color: var(--text-primary, #e2e8f0);
  margin-top: 1.5em;
  margin-bottom: 0.4em;
  line-height: 1.2;
}

.tiptap-editor-wrap .ProseMirror h2 {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--text-primary, #e2e8f0);
  margin-top: 1.3em;
  margin-bottom: 0.35em;
  line-height: 1.25;
}

.tiptap-editor-wrap .ProseMirror h3 {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-secondary, rgba(255,255,255,.55));
  margin-top: 1.1em;
  margin-bottom: 0.3em;
}

/* Paragraph */
.tiptap-editor-wrap .ProseMirror p {
  margin: 0 0 0.4em;
}

/* Links */
.tiptap-editor-wrap .ProseMirror a {
  color: var(--accent-l, #818cf8);
  text-decoration: underline;
  cursor: pointer;
}

/* Lists */
.tiptap-editor-wrap .ProseMirror ul,
.tiptap-editor-wrap .ProseMirror ol {
  padding-left: 1.5em;
  margin: 0.5em 0;
}

.tiptap-editor-wrap .ProseMirror li {
  margin: 0.15em 0;
}

/* Task lists */
.tiptap-editor-wrap .ProseMirror ul[data-type="taskList"] {
  list-style: none;
  padding-left: 0;
}

.tiptap-editor-wrap .ProseMirror ul[data-type="taskList"] li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.tiptap-editor-wrap .ProseMirror ul[data-type="taskList"] li label {
  margin-top: 3px;
}

/* Blockquote */
.tiptap-editor-wrap .ProseMirror blockquote {
  border-left: 4px solid var(--border, rgba(255,255,255,.2));
  padding: 0.5rem 1rem;
  margin: 0.75em 0;
  color: var(--text-secondary, rgba(255,255,255,.55));
  background: var(--bg-toolbar, rgba(255,255,255,.04));
  border-radius: 0 6px 6px 0;
  font-style: italic;
}

/* Code blocks */
.tiptap-editor-wrap .ProseMirror pre {
  background: #1e293b;
  color: var(--text-primary);
  padding: 1rem 1.25rem;
  border-radius: 8px;
  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.5;
  overflow-x: auto;
  margin: 0.75em 0;
}

.tiptap-editor-wrap .ProseMirror pre code {
  color: inherit;
  background: none;
  font-size: inherit;
  padding: 0;
}

/* Inline code */
.tiptap-editor-wrap .ProseMirror code {
  background: rgba(255,255,255,.08);
  color: #fca5a5;
  padding: 0.15em 0.35em;
  border-radius: 4px;
  font-size: 0.88em;
  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;
}

/* Horizontal rule */
.tiptap-editor-wrap .ProseMirror hr {
  border: none;
  border-top: 2px solid var(--border);
  margin: 1.5em 0;
}

/* Images */
.tiptap-editor-wrap .ProseMirror img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 0.5em 0;
}

/* Tables */
.tiptap-editor-wrap .ProseMirror table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.75em 0;
  overflow: hidden;
  border-radius: 6px;
}

.tiptap-editor-wrap .ProseMirror th,
.tiptap-editor-wrap .ProseMirror td {
  border: 1px solid var(--border);
  padding: 0.5rem 0.75rem;
  text-align: left;
  vertical-align: top;
  min-width: 80px;
}

.tiptap-editor-wrap .ProseMirror th {
  background: var(--bg-toolbar, rgba(255,255,255,.06));
  font-weight: 700;
  color: var(--text-primary, #e2e8f0);
  font-size: 0.88em;
}

/* Selected cells */
.tiptap-editor-wrap .ProseMirror .selectedCell {
  background: rgba(59,130,246,.2);
}

/* Placeholder */
.tiptap-editor-wrap .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: var(--text-muted, rgba(255,255,255,.35));
  pointer-events: none;
  height: 0;
  font-style: italic;
}

/* Highlight */
.tiptap-editor-wrap .ProseMirror mark {
  background: rgba(250,204,21,.25);
  color: #fde047;
  padding: 0.1em 0.15em;
  border-radius: 2px;
}

/* Collaboration cursors */
.collaboration-cursor__caret {
  border-left: 2px solid;
  border-right: none;
  margin-left: -1px;
  margin-right: -1px;
  pointer-events: none;
  position: relative;
  word-break: normal;
}

.collaboration-cursor__label {
  position: absolute;
  top: -1.4em;
  left: -1px;
  font-size: 10px;
  font-weight: 700;
  line-height: normal;
  padding: 0.1rem 0.35rem;
  border-radius: 3px 3px 3px 0;
  white-space: nowrap;
  color: #fff;
  -webkit-user-select: none;
          user-select: none;
}

/* ═══════════════════════════════════════════════════════════════════════════
   Editor de documentación en móvil
   ───────────────────────────────────────────────────────────────────────────
   La barra superior llevaba siete controles en una fila (volver, miga, título,
   estado, versión, guardar, publicar y panel): en un móvil los botones de
   guardar quedaban fuera de la pantalla. Ahora la barra envuelve y el panel de
   metadatos pasa de 300 px fijos a una franja inferior.
   ═══════════════════════════════════════════════════════════════════════════ */
@media (max-width: 900px) {
  .docs-editor-topbar {
    flex-wrap: wrap;
    height: auto !important;
    min-height: 48px;
    padding: 8px 10px !important;
    row-gap: 6px;
  }

  .docs-editor-topbar > span {
    font-size: 0.78rem;
  }

  .docs-editor-body {
    flex-direction: column;
  }

  .docs-editor-main {
    min-height: 0;
  }

  .docs-editor-side.is-open {
    width: 100% !important;
    min-width: 0 !important;
    max-height: 45dvh;
    border-left: 0 !important;
    border-top: 1px solid var(--border);
  }

  .tiptap-toolbar {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .tiptap-toolbar::-webkit-scrollbar { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/tiptap-editor.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF,qBAAqB;AACrB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;AACT;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,oDAAoD;EACpD,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mDAAmD;EACnD,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,SAAO;EACP,oBAAoB;EACpB,aAAa;EACb,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,UAAU;AACV;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,0DAA0D;EAC1D,oBAAoB;EACpB,gBAAgB;EAChB,mDAAmD;EACnD,oDAAoD;EACpD,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,iEAAiE;EACjE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iEAAiE;AACnE;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,WAAW;EACX,+CAA+C;EAC/C,oBAAoB;EACpB,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;;;;;gFAOgF;AAChF;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,qCAAqC,aAAa,EAAE;AACtD","sourcesContent":["/* ── TipTap Editor Styles — CMDB Docs ──────────────────────────────────────── */\r\n\r\n/* Editor container */\r\n.tiptap-editor-wrap {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-card, #0d0f1a);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  flex: 1;\r\n}\r\n\r\n/* Toolbar */\r\n.tiptap-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2px;\r\n  padding: 6px 10px;\r\n  background: var(--bg-toolbar, rgba(255,255,255,.04));\r\n  border-bottom: 1px solid var(--border);\r\n  align-items: center;\r\n}\r\n\r\n.tiptap-toolbar-group {\r\n  display: flex;\r\n  gap: 1px;\r\n  align-items: center;\r\n}\r\n\r\n.tiptap-toolbar-group + .tiptap-toolbar-group {\r\n  margin-left: 4px;\r\n  padding-left: 6px;\r\n  border-left: 1px solid var(--border);\r\n}\r\n\r\n.tiptap-toolbar button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 28px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  transition: background 0.12s, color 0.12s;\r\n}\r\n\r\n.tiptap-toolbar button:hover {\r\n  background: var(--slate-200);\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.tiptap-toolbar button.is-active {\r\n  background: var(--accent, #6366f1);\r\n  color: #fff;\r\n}\r\n\r\n.tiptap-toolbar button:disabled {\r\n  opacity: 0.35;\r\n  cursor: default;\r\n}\r\n\r\n.tiptap-toolbar select {\r\n  height: 28px;\r\n  border: 1px solid var(--border);\r\n  border-radius: 4px;\r\n  background: var(--bg-input, rgba(255,255,255,.05));\r\n  font-size: 12px;\r\n  padding: 0 6px;\r\n  color: var(--text-primary, #e2e8f0);\r\n  cursor: pointer;\r\n}\r\n\r\n/* ProseMirror content area */\r\n.tiptap-editor-wrap .ProseMirror {\r\n  flex: 1;\r\n  padding: 1.5rem 2rem;\r\n  outline: none;\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\r\n  font-size: 15px;\r\n  line-height: 1.7;\r\n  color: var(--text-primary, #e2e8f0);\r\n  min-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror > * + * {\r\n  margin-top: 0.5em;\r\n}\r\n\r\n/* Headings */\r\n.tiptap-editor-wrap .ProseMirror h1 {\r\n  font-size: 1.85rem;\r\n  font-weight: 800;\r\n  color: var(--text-primary, #e2e8f0);\r\n  margin-top: 1.5em;\r\n  margin-bottom: 0.4em;\r\n  line-height: 1.2;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror h2 {\r\n  font-size: 1.45rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary, #e2e8f0);\r\n  margin-top: 1.3em;\r\n  margin-bottom: 0.35em;\r\n  line-height: 1.25;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror h3 {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  margin-top: 1.1em;\r\n  margin-bottom: 0.3em;\r\n}\r\n\r\n/* Paragraph */\r\n.tiptap-editor-wrap .ProseMirror p {\r\n  margin: 0 0 0.4em;\r\n}\r\n\r\n/* Links */\r\n.tiptap-editor-wrap .ProseMirror a {\r\n  color: var(--accent-l, #818cf8);\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Lists */\r\n.tiptap-editor-wrap .ProseMirror ul,\r\n.tiptap-editor-wrap .ProseMirror ol {\r\n  padding-left: 1.5em;\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror li {\r\n  margin: 0.15em 0;\r\n}\r\n\r\n/* Task lists */\r\n.tiptap-editor-wrap .ProseMirror ul[data-type=\"taskList\"] {\r\n  list-style: none;\r\n  padding-left: 0;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror ul[data-type=\"taskList\"] li {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 8px;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror ul[data-type=\"taskList\"] li label {\r\n  margin-top: 3px;\r\n}\r\n\r\n/* Blockquote */\r\n.tiptap-editor-wrap .ProseMirror blockquote {\r\n  border-left: 4px solid var(--border, rgba(255,255,255,.2));\r\n  padding: 0.5rem 1rem;\r\n  margin: 0.75em 0;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  background: var(--bg-toolbar, rgba(255,255,255,.04));\r\n  border-radius: 0 6px 6px 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* Code blocks */\r\n.tiptap-editor-wrap .ProseMirror pre {\r\n  background: #1e293b;\r\n  color: var(--text-primary);\r\n  padding: 1rem 1.25rem;\r\n  border-radius: 8px;\r\n  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  overflow-x: auto;\r\n  margin: 0.75em 0;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror pre code {\r\n  color: inherit;\r\n  background: none;\r\n  font-size: inherit;\r\n  padding: 0;\r\n}\r\n\r\n/* Inline code */\r\n.tiptap-editor-wrap .ProseMirror code {\r\n  background: rgba(255,255,255,.08);\r\n  color: #fca5a5;\r\n  padding: 0.15em 0.35em;\r\n  border-radius: 4px;\r\n  font-size: 0.88em;\r\n  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', monospace;\r\n}\r\n\r\n/* Horizontal rule */\r\n.tiptap-editor-wrap .ProseMirror hr {\r\n  border: none;\r\n  border-top: 2px solid var(--border);\r\n  margin: 1.5em 0;\r\n}\r\n\r\n/* Images */\r\n.tiptap-editor-wrap .ProseMirror img {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 6px;\r\n  margin: 0.5em 0;\r\n}\r\n\r\n/* Tables */\r\n.tiptap-editor-wrap .ProseMirror table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  margin: 0.75em 0;\r\n  overflow: hidden;\r\n  border-radius: 6px;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror th,\r\n.tiptap-editor-wrap .ProseMirror td {\r\n  border: 1px solid var(--border);\r\n  padding: 0.5rem 0.75rem;\r\n  text-align: left;\r\n  vertical-align: top;\r\n  min-width: 80px;\r\n}\r\n\r\n.tiptap-editor-wrap .ProseMirror th {\r\n  background: var(--bg-toolbar, rgba(255,255,255,.06));\r\n  font-weight: 700;\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: 0.88em;\r\n}\r\n\r\n/* Selected cells */\r\n.tiptap-editor-wrap .ProseMirror .selectedCell {\r\n  background: rgba(59,130,246,.2);\r\n}\r\n\r\n/* Placeholder */\r\n.tiptap-editor-wrap .ProseMirror p.is-editor-empty:first-child::before {\r\n  content: attr(data-placeholder);\r\n  float: left;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n  pointer-events: none;\r\n  height: 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* Highlight */\r\n.tiptap-editor-wrap .ProseMirror mark {\r\n  background: rgba(250,204,21,.25);\r\n  color: #fde047;\r\n  padding: 0.1em 0.15em;\r\n  border-radius: 2px;\r\n}\r\n\r\n/* Collaboration cursors */\r\n.collaboration-cursor__caret {\r\n  border-left: 2px solid;\r\n  border-right: none;\r\n  margin-left: -1px;\r\n  margin-right: -1px;\r\n  pointer-events: none;\r\n  position: relative;\r\n  word-break: normal;\r\n}\r\n\r\n.collaboration-cursor__label {\r\n  position: absolute;\r\n  top: -1.4em;\r\n  left: -1px;\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  padding: 0.1rem 0.35rem;\r\n  border-radius: 3px 3px 3px 0;\r\n  white-space: nowrap;\r\n  color: #fff;\r\n  user-select: none;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════════════════════\r\n   Editor de documentación en móvil\r\n   ───────────────────────────────────────────────────────────────────────────\r\n   La barra superior llevaba siete controles en una fila (volver, miga, título,\r\n   estado, versión, guardar, publicar y panel): en un móvil los botones de\r\n   guardar quedaban fuera de la pantalla. Ahora la barra envuelve y el panel de\r\n   metadatos pasa de 300 px fijos a una franja inferior.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n@media (max-width: 900px) {\r\n  .docs-editor-topbar {\r\n    flex-wrap: wrap;\r\n    height: auto !important;\r\n    min-height: 48px;\r\n    padding: 8px 10px !important;\r\n    row-gap: 6px;\r\n  }\r\n\r\n  .docs-editor-topbar > span {\r\n    font-size: 0.78rem;\r\n  }\r\n\r\n  .docs-editor-body {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .docs-editor-main {\r\n    min-height: 0;\r\n  }\r\n\r\n  .docs-editor-side.is-open {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-height: 45dvh;\r\n    border-left: 0 !important;\r\n    border-top: 1px solid var(--border);\r\n  }\r\n\r\n  .tiptap-toolbar {\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    scrollbar-width: none;\r\n  }\r\n\r\n  .tiptap-toolbar::-webkit-scrollbar { display: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
